import { Address } from 'viem'

export const EMPTY_ADDRESS: Address = '0x0000000000000000000000000000000000000000'
